

import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleDistributorUser = (id) => {
  return useQuery({
    queryKey: ['viewSingleDistributorUser', id],
    enabled: !!id, 
    queryFn: async ({ queryKey }) => {
      const distributerid = queryKey[1];
      const res = await api.get(`/distributors/user/show/${distributerid}`);
      return res.data;
    },
  });
};